import React from 'react';

export const Tasks = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) => {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.90662 1.94744C6.04902 1.56779 5.88353 1.13446 5.51238 0.950544L5.43725 0.917928C5.0576 0.775524 4.62427 0.941018 4.44036 1.31216L2.59048 5.04369L1.97328 4.35654L1.91152 4.29484C1.61129 4.02576 1.15022 4.02064 0.843514 4.29629C0.5149 4.59163 0.487925 5.09744 0.783263 5.42605L1.5325 6.25971L1.63016 6.35852C1.73227 6.4525 1.84738 6.53167 1.97215 6.59349C2.69795 6.95314 3.57787 6.65632 3.93752 5.93052L5.874 2.02257L5.90662 1.94744Z"
          fill="currentColor"
        />
        <path
          d="M11.4571 5.316C11.4571 4.87417 11.0989 4.516 10.6571 4.516H6.65706L6.57527 4.52013C6.17186 4.5611 5.85706 4.90179 5.85706 5.316C5.85706 5.75783 6.21523 6.116 6.65706 6.116H10.6571L10.7389 6.11187C11.1423 6.0709 11.4571 5.73021 11.4571 5.316Z"
          fill="currentColor"
        />
        <path
          d="M10.8475 7.84933C11.2894 7.84933 11.6475 8.2075 11.6475 8.64933C11.6475 9.06355 11.3327 9.40423 10.9293 9.4452L10.8475 9.44933H1.13325C0.691424 9.44933 0.333252 9.09116 0.333252 8.64933C0.333252 8.23512 0.648052 7.89443 1.05146 7.85346L1.13325 7.84933H10.8475Z"
          fill="currentColor"
        />
        <path
          d="M11.6475 11.9827C11.6475 11.5408 11.2894 11.1827 10.8475 11.1827H1.13325L1.05146 11.1868C0.648052 11.2278 0.333252 11.5685 0.333252 11.9827C0.333252 12.4245 0.691424 12.7827 1.13325 12.7827H10.8475L10.9293 12.7785C11.3327 12.7376 11.6475 12.3969 11.6475 11.9827Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
